// src/ExamQuestions5.jsx
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import styles from '../css/modules/ExamQuestions.module.css';

const ExamQuestions5 = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate('/test-bezpieczenstwo-strzelnica-egzamin-na-bron');
  };

  return (
    <div className={styles.contactContainer}>
      <Helmet>
        <title>Zdobądź patent strzelecki – ucz się na pytaniach egzaminacyjnych na broń</title>
        <meta
          name="description"
          content="Zbiór pytań egzaminacyjnych dotyczących zasad bezpieczeństwa i procedur obowiązujących na strzelnicy. Dowiedz się, jak zachować się podczas strzelania."
        />
      </Helmet>

      <div className={styles.content}>
        <h1 className="mainHeader">Patent strzelecki i pozwolenie na broń – trenuj na pytaniach jak na egzaminie</h1>

        <div className="intro">
          Aby zdobyć <strong>patent strzelecki</strong> i przejść <strong>egzamin na broń</strong>, musisz znać nie tylko teorię prawną, ale też zasady bezpieczeństwa obowiązujące na strzelnicy. To właśnie one mają kluczowe znaczenie dla Twojego bezpieczeństwa oraz innych uczestników.

          📘 Poniższe pytania pochodzą z oficjalnej bazy przygotowanej przez Polski Związek Strzelectwa Sportowego (PZSS). Opracowaliśmy je z komentarzami i dodatkowymi przykładami, aby przygotowanie do egzaminu było łatwiejsze i skuteczniejsze.

          ✅ Jeśli zależy Ci na <strong>pozwoleniu na broń</strong>, zapamiętaj te zasady – nie tylko po to, by zdać test, ale przede wszystkim, by być odpowiedzialnym strzelcem.

          🔗 Sprawdź też nasze materiały dodatkowe na stronie <a href="https://pistolet.org" target="_blank" rel="noopener noreferrer">pistolet.org</a>.
        </div>

        <h2>📢 Komendy i procedury strzeleckie</h2>
        <ul className="reasonList">
          <li className={styles.customAnswer}>
            <h3>66. 🛑 Kto może wydać komendę „STOP”?</h3>
            <p>Każda osoba znajdująca się na strzelnicy ma prawo wydać komendę „STOP”, jeśli zauważy sytuację zagrażającą bezpieczeństwu. Komenda ta natychmiast przerywa wszelkie czynności – to zasada nadrzędna w każdej sytuacji, niezależnie od statusu uczestnika.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>67. 🐶 Czy można przyprowadzić zwierzęta na strzelnicę?</h3>
            <p>Zwierzęta mogą przebywać na terenie strzelnicy tylko pod ścisłym nadzorem i na uwięzi. Opiekun musi zapewnić, że ich obecność nie zakłóca porządku i nie naraża innych uczestników na ryzyko. W kontekście <strong>egzaminu na broń</strong> pytanie to sprawdza znajomość zasad organizacyjnych.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>68. 🔃 Co oznacza komenda „ROZŁADUJ”?</h3>
            <p>„ROZŁADUJ” to polecenie obowiązkowego rozbrojenia broni: należy wyjąć magazynek, usunąć nabój z komory, otworzyć zamek i odłożyć broń w bezpiecznym kierunku – zwykle lufą w stronę tarcz. To jedna z kluczowych procedur przed uzyskaniem <strong>pozwolenia na broń</strong>.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>69. 🚫 Czy można zostawić załadowaną broń podczas przerwy?</h3>
            <p>Bezwzględnie nie. Załadowana broń bez kontroli jest zagrożeniem życia. Odłożenie jej w takim stanie, nawet na chwilę, może być podstawą do przerwania egzaminu lub cofnięcia uprawnień.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>70. ⏸️ Jak prawidłowo odkładać broń w trakcie konkurencji?</h3>
            <p>Po rozładowaniu – należy wyjąć magazynek, usunąć nabój z komory, otworzyć zamek i skierować lufę w stronę tarcz. Niewłaściwe odkładanie broni to częsty błąd kandydatów podczas <strong>egzaminu na patent strzelecki</strong>.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>71. 🛑 Co robić natychmiast po usłyszeniu komendy „STOP”?</h3>
            <p>Należy natychmiast przestać strzelać, zabezpieczyć broń i zachować spokój. Brak reakcji na tę komendę może skutkować wykluczeniem z egzaminu lub nawet odpowiedzialnością dyscyplinarną.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>72. 📥 Co oznacza komenda „ŁADUJ”?</h3>
            <p>To sygnał do załadowania magazynka, włożenia go do broni i wprowadzenia naboju do komory. Po tej komendzie nie wolno jednak jeszcze strzelać – czekamy na „OGIEŃ”.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>73. 🎯 Czy „strzelanie na sucho” jest dozwolone?</h3>
            <p>Tak, ale tylko w wyznaczonym miejscu i za wyraźną zgodą prowadzącego strzelanie. "Na sucho" oznacza bez amunicji – to technika treningowa, ale musi odbywać się zgodnie z regulaminem.</p>
          </li>
        </ul>

        <h2>👮 Obowiązki i zachowania uczestników</h2>
        <ul className="reasonList">
          <li className={styles.customAnswer}>
            <h3>74. 🚷 Czy osoba naruszająca regulamin może zostać usunięta ze strzelnicy?</h3>
            <p>Tak. Prowadzący ma prawo natychmiast wyprosić uczestnika, który nie przestrzega zasad. Dotyczy to również kandydatów przystępujących do <strong>egzaminu na broń</strong>.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>75. 📦 Co trzeba zrobić z bronią po zakończeniu strzelania?</h3>
            <p>Należy ją rozładować, otworzyć komorę, pokazać do kontroli i bezwzględnie opuścić stanowisko dopiero po zatwierdzeniu przez prowadzącego. To obowiązek zarówno regulaminowy, jak i prawny.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>76. 📛 Jaką komendą przerywa się strzelanie?</h3>
            <p>„STOP” – to sygnał natychmiastowego wstrzymania wszelkiej aktywności. Nie wolno jej ignorować pod żadnym pozorem – to jedno z pytań obowiązkowych na <strong>patencie strzeleckim</strong>.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>77. 🔓 Kiedy należy rozładować broń?</h3>
            <p>Bezpośrednio po zakończeniu serii lub na komendę „ROZŁADUJ”. Nawet jeśli strzelanie trwało tylko chwilę – broń musi zostać zabezpieczona.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>78. 🔫 Co dokładnie zrobić po „ŁADUJ”?</h3>
            <p>Załadować, wprowadzić nabój do komory, zabezpieczyć broń i czekać na sygnał do rozpoczęcia ognia. Strzelanie bez komendy to poważne naruszenie.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>79. ✔️ Jak wygląda zakończenie strzelania?</h3>
            <p>Broń musi być rozładowana, przedstawiona do kontroli, a następnie przenoszona z otwartą komorą i bez magazynka. Każde odstępstwo grozi wykluczeniem z zawodów lub egzaminu.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>80. 🐦 Czy można celować do przypadkowych przedmiotów?</h3>
            <p>Nie. Broń można kierować tylko w stronę celów wyznaczonych przez organizatora. Celowanie w inne osoby lub przedmioty to najpoważniejsze naruszenie zasad.</p>
          </li>
        </ul>

        <h2>📋 Rola prowadzącego i regulamin</h2>
        <ul className="reasonList">
          <li className={styles.customAnswer}>
            <h3>81. 👮 Jakie są podstawowe obowiązki prowadzącego strzelanie?</h3>
            <p>
              Czuwanie nad bezpieczeństwem, kontrola broni, prowadzenie książki ewidencyjnej i udzielanie komend. Prowadzący odpowiada również za przebieg <strong>egzaminu na patent strzelecki</strong> i może przerwać go w dowolnym momencie.
            </p>
          </li>

          <li className={styles.customAnswer}>
            <h3>82. ✍️ Czy zapoznanie się z regulaminem jest obowiązkowe?</h3>
            <p>Tak. Każdy uczestnik – niezależnie od doświadczenia – musi podpisać oświadczenie o zapoznaniu się z regulaminem. Bez tego nie można rozpocząć strzelania.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>83. 🚫 Jakie zachowania są bezwzględnie zakazane?</h3>
            <p>
              Niedozwolone jest dotykanie cudzej broni bez zgody, wchodzenie na stanowiska bez pozwolenia oraz lekceważenie poleceń prowadzącego. Naruszenia mogą zakończyć się cofnięciem <strong>pozwolenia na broń</strong>.
            </p>
          </li>
        </ul>

        <div className="buttonContainer">
          <button onClick={handleNext} className={styles.secondaryButton}>
            👉 Kolejne pytania
          </button>
          <button onClick={() => navigate('/')} className={styles.primaryButton}>
            Rozwiąż testy z prawdziwych egzaminów na broń
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExamQuestions5;
